/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as getHeaderNotificationsAction from '../actions/header-notifications.action';
import { NotificationsService } from 'app/shared/services';

@Injectable()
export class HeaderNotificationsEffects {
  getHeaderNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getHeaderNotificationsAction.GET_HEADER_NOTIFICATIONS),
      switchMap((action: getHeaderNotificationsAction.GetHeaderNotifications) => {
        return this.notificationsService.getUserNotifications().pipe(
          map((response) => {
            return new getHeaderNotificationsAction.GetHeaderNotificationsSuccess(response);
          }),
          catchError((error) => of(new getHeaderNotificationsAction.GetHeaderNotificationsFail(error.message)))
        );
      })
    )
  );

  updateHeaderNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getHeaderNotificationsAction.UPDATE_HEADER_NOTIFICATIONS),
      switchMap((action: getHeaderNotificationsAction.UpdateHeaderNotifications) => {
        return this.notificationsService.updateNotification(action.payload).pipe(
          map((response: any) => {
            return new getHeaderNotificationsAction.UpdateHeaderNotificationsSuccess({
              ...action.payload,
            });
          }),
          catchError((error) => of(new getHeaderNotificationsAction.GetHeaderNotificationsFail(error.message)))
        );
      })
    )
  );

  deleteHeaderNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getHeaderNotificationsAction.DELETE_HEADER_NOTIFICATIONS),
      switchMap((action: getHeaderNotificationsAction.DeleteHeaderNotifications) => {
        return this.notificationsService.dismissNotification(action.payload).pipe(
          map((response: any) => {
            return new getHeaderNotificationsAction.DeleteHeaderNotificationsSuccess(action.payload);
          }),
          catchError((error) => of(new getHeaderNotificationsAction.GetHeaderNotificationsFail(error.message)))
        );
      })
    )
  );

  constructor(private actions$: Actions, private notificationsService: NotificationsService) {}
}
